import PageContainer from '@/common/components/PageContainer'
import EditEventListing from '@/modules/events/components/EditEventListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function UpdateEventPage() {
	return (
		<PageContainer>
			<EditEventListing />
		</PageContainer>
	)
}

const GuardedUpdateEventPage = withUserPermission(UpdateEventPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.WEB_SETTING],
})

export default GuardedUpdateEventPage
